import React, { useContext, useEffect, useState } from 'react';
import { contextData } from '../../App';

import june13_1 from '../../Assests/FifaFanFest/june13-1.jpg';
import june13_2 from '../../Assests/FifaFanFest/june13-2.jpg';
import june13_3 from '../../Assests/FifaFanFest/june13-3.jpg';
import june13_4 from '../../Assests/FifaFanFest/june13-4.jpg';
import june13_5 from '../../Assests/FifaFanFest/june13-5.jpg';
import june17_1 from '../../Assests/FifaFanFest/june17-1.jpg';
import june17_2 from '../../Assests/FifaFanFest/june17-2.jpg';
import june17_3 from '../../Assests/FifaFanFest/june17-3.jpg';
import june17_4 from '../../Assests/FifaFanFest/june17-4.jpg';
import june17_5 from '../../Assests/FifaFanFest/june17-5.jpg';
import june17_6 from '../../Assests/FifaFanFest/june17-6.jpg';
import june17_7 from '../../Assests/FifaFanFest/june17-7.jpg';
import july11_1 from '../../Assests/FifaFanFest/july11-1.jpg';
import july11_2 from '../../Assests/FifaFanFest/july11-2.jpg';
import july11_3 from '../../Assests/FifaFanFest/july11-3.jpg';

const performances = [
  {
    date: 'June 12, 2026',
    title: 'Summer Camp Performance',
    match: 'Before the USA vs. Paraguay Match',
    description:
      'Our CHILANKA Summer Camp dancers took the stage for a special pre-match performance, showcasing a fun, high-energy global fusion production inspired by cultures from around the world.',
    videoId: 'kYNfUK3f-Hw',
    photos: [june13_1, june13_5, june13_2, june13_3, june13_4],
  },
  {
    date: 'June 17, 2026',
    title: 'Halftime Show',
    match: 'Ghana vs. Panama Match',
    description:
      'Our dancers returned to the Fan Festival to perform the halftime show during the Ghana vs. Panama match, sharing the grace of Indian classical dance and the joy of our youngest performers with fans from around the world.',
    videoId: '6JNxE-5Zx80',
    photos: [june17_1, june17_2, june17_3, june17_4, june17_5, june17_6, june17_7],
  },
  {
    date: 'Saturday, July 11, 2026',
    title: 'Halftime Show',
    match: 'England vs. Norway Quarter-Final',
    description:
      'For their final Fan Festival performance, our adult NatyaFusion dancers took the halftime stage during the England vs. Norway quarter-final on July 11, sharing the beauty of Indian classical dance with fans from around the world.',
    // No video yet — add the YouTube ID here (like the ones above) and the video will show up automatically.
    videoId: null,
    photos: [july11_1, july11_2, july11_3],
  },
];

function FifaFanFestPage() {
  const { setIsScrolled } = useContext(contextData);
  const [lightbox, setLightbox] = useState({ open: false, images: [], index: 0 });

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsScrolled(true);
    return () => setIsScrolled(false);
  }, [setIsScrolled]);

  const openLightbox = (images, index) => setLightbox({ open: true, images, index });
  const closeLightbox = () => setLightbox((lb) => ({ ...lb, open: false }));
  const prevPhoto = () => setLightbox((lb) => ({ ...lb, index: (lb.index - 1 + lb.images.length) % lb.images.length }));
  const nextPhoto = () => setLightbox((lb) => ({ ...lb, index: (lb.index + 1) % lb.images.length }));

  return (
    <div className='bg-white md:px-[192px] px-4 pt-[160px] pb-20'>

      {/* Lightbox */}
      {lightbox.open && (
        <div className='fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center' onClick={closeLightbox}>
          <button className='absolute top-4 right-6 text-white text-4xl font-bold' onClick={closeLightbox}>✕</button>
          <button className='absolute left-4 text-white text-5xl font-bold px-4' onClick={(e) => { e.stopPropagation(); prevPhoto(); }}>‹</button>
          <img src={lightbox.images[lightbox.index]} alt='' className='max-h-[90vh] max-w-[90vw] object-contain rounded-lg shadow-2xl' onClick={(e) => e.stopPropagation()} />
          <button className='absolute right-4 text-white text-5xl font-bold px-4' onClick={(e) => { e.stopPropagation(); nextPhoto(); }}>›</button>
          <div className='absolute bottom-4 text-white text-sm opacity-70'>{lightbox.index + 1} / {lightbox.images.length}</div>
        </div>
      )}

      {/* Page Header */}
      <div className='text-center mb-14'>
        <p className='text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-3'>⭐ Houston · June – July 2026 ⭐</p>
        <div className='flex items-center justify-center gap-4 mb-4'>
          <div className='w-14 h-[1px] bg-[#E40F94]'></div>
          <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
          <div className='w-2 h-2 border border-[#E40F94] rotate-45'></div>
          <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
          <div className='w-14 h-[1px] bg-[#E40F94]'></div>
        </div>
        <h1 className='font-bold md:text-[48px] text-[32px] leading-tight text-gray-900' style={{ fontFamily: "'Playfair Display', serif" }}>
          CHILANKA at the <em style={{ color: '#E40F94' }}>FIFA World Cup 2026™</em> Fan Festival
        </h1>
        <div className='w-16 h-[3px] bg-[#E40F94] rounded-full mx-auto mt-6'></div>
      </div>

      {/* Intro */}
      <div className='max-w-[860px] mx-auto text-center mb-20'>
        <p className='md:text-[18px] text-[16px] leading-relaxed text-gray-600'>
          In the summer of 2026, CHILANKA Dance School had the incredible honor of performing at the FIFA World Cup 2026™ Fan Festival
          in Houston, celebrating culture, community, and the universal language of dance on one of the world's biggest stages.
          Across three featured performances, our dancers—from young campers to our advanced youth and adult performers—shared
          the spirit of CHILANKA through performances that blended traditional roots with modern rhythm.
        </p>
      </div>

      {/* Performances */}
      <div className='space-y-24 max-w-[1100px] mx-auto'>
        {performances.map((p, i) => (
          <section key={p.date}>
            {/* Section heading */}
            <div className='text-center mb-10'>
              <p className='text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-2'>Performance {i + 1} · {p.date}</p>
              <h2 className='font-bold md:text-[36px] text-[26px] leading-tight text-gray-900' style={{ fontFamily: "'Playfair Display', serif" }}>
                {p.title} <em style={{ color: '#E40F94' }}>• {p.match}</em>
              </h2>
              <p className='mt-4 max-w-[760px] mx-auto md:text-[17px] text-[15px] text-gray-600 leading-relaxed'>{p.description}</p>
            </div>

            {/* Video */}
            {p.videoId && <div className='mb-10'>
              <p className='text-[15px] font-semibold text-gray-800 mb-3'>🎥 Performance Video</p>
              <div className='relative w-full overflow-hidden rounded-2xl shadow-xl' style={{ paddingTop: '56.25%' }}>
                <iframe
                  className='absolute inset-0 w-full h-full'
                  src={`https://www.youtube.com/embed/${p.videoId}`}
                  title={`${p.title} – ${p.date}`}
                  frameBorder='0'
                  allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                  allowFullScreen
                ></iframe>
              </div>
            </div>}

            {/* Photo gallery */}
            <div>
              <p className='text-[15px] font-semibold text-gray-800 mb-3'>📸 Photo Gallery</p>
              <div className='grid grid-cols-2 md:grid-cols-3 gap-4'>
                {p.photos.map((img, idx) => (
                  <div key={idx} className='group overflow-hidden rounded-xl shadow-lg shadow-pink-200 cursor-pointer' onClick={() => openLightbox(p.photos, idx)}>
                    <img src={img} alt={`${p.title} ${p.date} – ${idx + 1}`} loading='lazy' className='w-full h-[180px] md:h-[260px] object-cover transition-transform duration-500 group-hover:scale-105' />
                  </div>
                ))}
              </div>
            </div>

            {i < performances.length - 1 && (
              <div className='flex items-center justify-center gap-3 mt-24 text-[#E40F94]'>
                <span>♦</span><span>◇</span><span>♦</span>
              </div>
            )}
          </section>
        ))}
      </div>

    </div>
  );
}

export default FifaFanFestPage;
